import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { Status } from '../../models/ductech.enum';
import { SectionStatusModel } from '../../models/section-status.model';

function createInitialState(): SectionStatusModel {
  return {
    deliveryInfo: Status.NEEDS_REVIEW,
    additionalLoanApplication: Status.NOTHING,
    creditReport: Status.NOTHING,
    programSelectAndLock: Status.NOTHING,
    fees: Status.NOTHING,
    irs4506cInfo: Status.NOTHING,
    stateSpecific: Status.NOTHING,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'section-status-store' })
export class SectionStatusStore extends Store<SectionStatusModel> {
  constructor() {
    super(createInitialState());
  }
}
